module.exports = __webpack_public_path__ + "media/images/salespartner/bg-cta-left_sp-a655046caeb44f16eabbb0073a4bfc06.svg";